export const LINKED_FILES_BLOCK_SELECTOR = 'data-file-links-block'

export const LINKED_FILES_BLOCK_IDS_ATTRIBUTE = 'data-ids'

export const LINKED_FILES_ITEM_ID_ATTRIBUTE = 'data-file-id'

export const LINKED_FILES_BLOCK_QUERY = `[${LINKED_FILES_BLOCK_SELECTOR}]`

export const LINKED_FILES_ITEM_QUERY = `[${LINKED_FILES_ITEM_ID_ATTRIBUTE}]`

export const LINKED_FILES_BLOCK_DRAG_DATA_FORMAT = 'text/plain'

export const LINKED_FILES_BLOCK_DRAG_DATA_VALUE = 'file-links-block'

export const LINKED_FILES_BLOCK_DRAG_EFFECT_MOVE = 'move'

// We need to keep Base64 in editor HTML to avoid extra icon requests during TinyMCE interactions.
export const LINKED_FILES_BLOCK_FILE_ICON_BASE64 =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAOdEVYdFNvZnR3YXJlAEZpZ21hnrGWYwAAAcdJREFUeAHtl01OwkAYht9OG0FXPQKeQD2GC016AvEEyApJQIZAArpBTyCeoEEXbr2B3sDeQJaUtB1nWmIilNJpqZWkz4YJ8/fM93WmU6CgIB1KVCWlpo5SWUcCaPPUQgKUdSLuvtphjF0hIXxgiylk3G+cdWX6kbA/3bI6SiMjYEAFzKPt4fOjTL+VCNGRqTs2+QpG9boaMIYsKnTHI1VeqgWTKOPe9fllnK6rQgOz4ijkU5Q1tneY9FkQtAYmhUI6MlIEGdJvGlREWZQZWDVO+jIVSiKVuZCs1J8IhUm1BhOKPIV+pICHxcw1/+DNU0igMe/eLzDo8wN+ViFnoV+Tu8g/Qpv4d0KaTOObu5ca89hxVBuVuV3aNCxkLeS/UrzFAxmBq6jiJ9Z7K50QX3X71qyDqUdR7USEkAKplPUaxsYIpUVKKNEN0p5NKTWmcZvHTxm/J7k2eWeYVyCBUiYWX8hJXKnd3fa0bkzFSlGCZMqQTcp8qWDg2IMnYQdSVuYRsIOiQ5wLOnh9whYRY/J7UTC5jY/l+tDvstZwIs6bGjJk3aU/NGVayeO3O2w1Mks6b+rMrYfWRHULDkLJXbUJyV1XUCDLN4nfuHSMjNR1AAAAAElFTkSuQmCC'

export const LINKED_FILES_BLOCK_FILE_ICON_PUBLIC_URL =
  'https://files.idwell.com/sys/common_file_icon.png'
